/* Component Dependencies */
var offersAndPackagesTemplate = require('templates/offersAndPackages.hbs');
var AriesComponent = require('libs/aries-component');


AriesComponent.create({
  type: 'offersAndPackages',
  template: {
    'offersAndPackages': offersAndPackagesTemplate
  },
 
});
